import moment from "moment";

export function getDateFromOffset(utcString: string) {
  const offset = utcString.replace("UTC ", "").trim();
  const isoString = moment().utcOffset(offset).format("YYYY-MM-DDTHH:mm:ss");
  return new Date(isoString);
}

export function getDelayReasons(delayReason: Record<string, boolean> | undefined) {
  if (!delayReason || typeof delayReason !== "object") return;
  const selectedDelayReasons: string[] = [];
  Object.keys(delayReason).forEach((reasonKey: string) => {
    if (delayReason[reasonKey]) {
      selectedDelayReasons.push(reasonKey);
    }
  });
  return selectedDelayReasons.length ? selectedDelayReasons.join(", ") : undefined;
}

export function isPodAttachmentsValid(formValues: {
  selected_attachments?: Record<string, boolean>;
  file_attachments?: unknown[];
}) {
  const selectedAttachments = formValues.selected_attachments;
  if (!selectedAttachments) return false;

  let activeAttachmentCount = 0;
  Object.keys(selectedAttachments).forEach((key) => {
    if (selectedAttachments[key]) {
      activeAttachmentCount += 1;
    }
  });
  return activeAttachmentCount === (formValues.file_attachments?.length ?? 0);
}
